<template>
    <div class="c-oe col-xl-8 col-lg-8 col-md-8">
        <CCard :extra-style="cardStyle">
            <div :style="eyebrowStyle">Carry-over from previous period</div>
            <h2 :style="titleStyle">
                Please explain why no money was collected for the invoice sent in
                <span class="red" :style="accentStyle">{{ currentMonth }}</span>.
            </h2>
            <p :style="leadStyle">
                A short note helps TAG decide what to do with the outstanding balance.
            </p>

            <div :key="elementKey" :style="explanationFieldStyle">
                <label :style="labelStyle">Explanation</label>
                <textarea
                    v-model="saleLineItem.explanation"
                    :style="textareaStyle"
                    placeholder="What's the story with this one?"
                    @input="$emit('update:explanation', $event.target.value)"
                ></textarea>
            </div>
        </CCard>
    </div>
</template>

<script>
import CCard from "../c-design/CCard.vue";
import {
    C_INK,
    C_INK2,
    C_MUTED,
    C_HAIR,
    C_CREAM,
    C_RED,
    FONT_DISPLAY,
    FONT_BODY,
} from "../c-design/tokens";

/**
 * Stage 6 of the wizard redesign. No reasons list — just a single
 * explanation textarea. Form contract preserved (saleLineItem mutated
 * in place via v-model on `.explanation`; emits `update:explanation`
 * on each input).
 */
export default {
    name: "OverdueExplanationScreen",
    components: { CCard },
    props: {
        saleLineItem: {
            type: Object,
            required: true,
        },
        currentMonth: {
            type: String,
            default: "",
        },
    },
    computed: {
        elementKey() {
            const sli = this.saleLineItem;
            if (!sli.is_new_project && !sli.is_new_retainer) {
                return `${sli.deal_line_item.id}__${sli.period}__explanation_collected`;
            }
            return `${sli.id}__explanation_collected`;
        },
        cardStyle() {
            return { padding: '32px 36px' };
        },
        eyebrowStyle() {
            return {
                fontSize: '12px',
                color: C_MUTED,
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                fontWeight: 600,
                marginBottom: '6px',
            };
        },
        titleStyle() {
            return {
                margin: 0,
                fontFamily: FONT_DISPLAY,
                fontSize: '26px',
                fontWeight: 700,
                letterSpacing: '-0.6px',
                lineHeight: 1.15,
                color: C_INK,
            };
        },
        accentStyle() {
            return { color: C_RED };
        },
        leadStyle() {
            return {
                margin: '8px 0 22px',
                fontSize: '14px',
                color: C_MUTED,
                lineHeight: 1.55,
            };
        },
        explanationFieldStyle() {
            return { marginTop: '8px' };
        },
        labelStyle() {
            return {
                display: 'block', fontSize: '12px', color: C_INK2,
                fontWeight: 600, marginBottom: '6px',
            };
        },
        textareaStyle() {
            return {
                width: '100%', minHeight: '120px', padding: '14px',
                border: `1.5px solid ${C_HAIR}`, borderRadius: '14px',
                background: C_CREAM, resize: 'vertical',
                fontFamily: FONT_BODY, fontSize: '14px',
                color: C_INK, outline: 'none',
            };
        },
    },
};
</script>

<style scoped>
.c-oe .red { color: #E63946; }
</style>
